const temp = [
  {
    text: "BCE: Bachiller en Comercio Exterior",
    value: "BCE: Bachiller en Comercio Exterior"
  },
  { text: "Bachiller Contable", value: "Bachiller Contable" },
  {
    text: "Bachiller en Ciencias Sociales",
    value: "Bachiller en Ciencias Sociales"
  },
  { text: "Perito Mercantil", value: "Perito Mercantil" },
  { text: "Bachiller Comercial", value: "Bachiller Comercial" },
  {
    text: "Bachiller en Economia y Administración",
    value: "Bachiller en Economia y Administración"
  },
  { text: "Bachiller en Lengua", value: "Bachiller en Lengua" },
  { text: "Bachiller en Comunicación", value: "Bachiller en Comunicación" },
  { text: "TBachiller en Informática", value: "Bachiller en Informática" },
  {
    text: "Bachiller en Educación Física",
    value: "Bachiller en Educación Física"
  },
  { text: "Bachiller en Turismo", value: "Bachiller en Turismo" },
  { text: "Bachiller en Artes", value: "Bachiller en Artes" },
  {
    text: "Técnico en la Industria Alimentaria",
    value: "Técnico en la Industria Alimentaria"
  },
  { text: "Maestro Mayor de Obrs", value: "Maestro Mayor de Obrs" },

  {
    text: "Técnico en Industria y Diseño del Mueble",
    value: "Técnico en Industria y Diseño del Mueble"
  },
  {
    text: "Técnico con orientación en Instalaciones Electricas",
    value: "Técnico con orientación en Instalaciones Electricas"
  },
  {
    text: "Técnico con orientación en Electrónica",
    value: "Técnico con orientación en Electrónica"
  },
  {
    text: "Técnico con orientación en Telecomunicaciones",
    value: "Técnico con orientación en Telecomunicaciones"
  },
  {
    text: "Técnico en la Industria Gráfica",
    value: "Técnico en la Industria Gráfica"
  },
  {
    text: "Técnico en Diseño y Producción de Indumentaria",
    value: "Técnico en Diseño y Producción de Indumentaria"
  },
  { text: "Técnico Mecánico", value: "Técnico Mecánico" },
  {
    text: "Técnico en la Industria de la Orfebreria",
    value: "Técnico en la Industria de la Orfebreria"
  },
  {
    text: "Técnico en Comunicaciones Publicitarias",
    value: "Técnico en Comunicaciones Publicitarias"
  },
  { text: "Bachiller Pedagógico", value: "Bachiller Pedagógico" },
  { text: "Bachiller", value: "Bachiller" }
];

export default temp;
